/**
 * TypeMixDonut — SVG donut breaking a total down by project type.
 * Radiance Command palette:
 *   new     → coral gradient
 *   ongoing → indigo (#6366F1)
 *   land    → emerald mint (#34D399)
 */
export default function TypeMixDonut({ segments, size = 160, stroke = 18 }) {
  const total = segments.reduce((s, seg) => s + seg.value, 0) || 1;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const cx = size / 2;
  const cy = size / 2;

  const colors = {
    new: "url(#cf-mix-coral)",
    ongoing: "#818CF8",
    land: "#34D399",
  };

  let cumulative = 0;
  const arcs = segments.map((seg) => {
    const frac = seg.value / total;
    const length = c * frac;
    const gap = c - length;
    const offset = c * (1 - cumulative);
    cumulative += frac;
    return {
      ...seg,
      dashArray: `${length} ${gap}`,
      dashOffset: offset,
    };
  });

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <defs>
        <linearGradient id="cf-mix-coral" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#E11D48" />
          <stop offset="50%" stopColor="#F43F5E" />
          <stop offset="100%" stopColor="#FB7185" />
        </linearGradient>
      </defs>
      <circle
        cx={cx}
        cy={cy}
        r={r}
        fill="none"
        stroke="rgba(255,255,255,0.10)"
        strokeWidth={stroke}
      />
      {arcs.map((a) => (
        <circle
          key={a.key}
          cx={cx}
          cy={cy}
          r={r}
          fill="none"
          stroke={colors[a.key] || "#A1A1AA"}
          strokeWidth={stroke}
          strokeDasharray={a.dashArray}
          strokeDashoffset={a.dashOffset}
          strokeLinecap="butt"
          transform={`rotate(-90 ${cx} ${cy})`}
          style={{ transition: "stroke-dasharray 0.6s ease" }}
        />
      ))}
    </svg>
  );
}
